
import React, { useState, useEffect } from 'react';
import { Button, Alert } from "react-bootstrap";
import Popup from 'reactjs-popup';

import PropTypes from "prop-types";

EliminaChiusuraAziendale.propTypes = {
    annulla: PropTypes.func,
    conferma: PropTypes.func,
    open: PropTypes.bool,
    message: PropTypes.array
}

function EliminaChiusuraAziendale({ annulla, conferma, open, message }) {

    const [inizio, setInizio] = useState("");
    const [fine, setFine] = useState("");

    useEffect(() => {
        clear();
    }, [open])

    const clear = () => {
        setInizio("");
        setFine("");
    }

    const confermaEliminazione = () => {
        if (!inizio || !fine) {
            alert("Attenzione! Impostare sia la data di inizio che di fine periodo")
        } else if (new Date(inizio) > new Date(fine)) {
            alert("Attenzione! La data di inizio periodo è successiva a quella di fine periodo")
        } else {
            conferma(inizio, fine)
        }
    }

    const annullaEliminazione = () => {
        annulla()
        clear()
    }

    return (
        <Popup closeOnDocumentClick={false} open={open}><div>
            {
                message && message.map((data, key) => (
                    <Alert variant={data.tipo} id="message" key={key}>
                        {data.descrizione}
                    </Alert>
                ))
            }
            <div className="formGroup" id="eliminachiusuraaziendale">
                <h5 className="inEvidenza">Elimina Chiusura Aziendale</h5>
                <div className="date-container">
                    <div className="date-field">
                        <label htmlFor="inizio" className="inEvidenza">inizio</label>
                        <input
                            className='form-control'
                            id="inizio"
                            type="date"
                            value={inizio}
                            onChange={(event) => {
                                setInizio(event.target.value);
                            }}
                        />
                    </div>
                    <div className="date-field">
                        <label htmlFor="fine" className="inEvidenza">fine</label>
                        <input
                            className='form-control'
                            id="fine"
                            type="date"
                            value={fine}
                            onChange={(event) => {
                                setFine(event.target.value);
                            }}
                        />
                    </div>
                </div>
                <div id="action" className="action">
                    <Button className="btnGenerale" variant="flat" size="sm" id="annulla"
                        onClick={() => { annullaEliminazione() }}>annulla</Button>
                    <Button className="btnGenerale" variant="flat" size="sm" id="conferma"
                        onClick={() => { confermaEliminazione() }}>conferma</Button>
                </div>
            </div>
        </div>
        </Popup>)
}


export default EliminaChiusuraAziendale;
